import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { CardProps, cardStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-card',
  template: `
    <div [ngClass]="card">
      <kite-stack direction="column" align="start">
        <ng-content></ng-content>
      </kite-stack>
    </div>
  `,
})
export class CardComponent {
  /**
   * CSS del componente
   */
   @Input() css: CardProps['css'];

  public get card(): string[] {
    return [cardStyles({ css: this.css }).className];
  }
}